import script from "./FilterOrders.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterOrders.vue?vue&type=script&setup=true&lang=js"

import "./FilterOrders.vue?vue&type=style&index=0&id=3bb5ee75&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bb5ee75"]])

export default __exports__